// extracted by mini-css-extract-plugin
export default {"spinning_loader":"spinning-loader-container_spinning_loader__rKD6u","rotatate":"spinning-loader-container_rotatate__eFbxy"};